export default {"src":"/_next/static/media/klimmen.7fa8e02a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};